import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BourqueCoreModule } from '@bds/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DevExtremeModule } from 'devextreme-angular';

import { RtAutoCarAssignDetailsDialogComponent } from './rt-auto-car-assign-details-dialog/rt-auto-car-assign-details-dialog.component';
import { RtAutoCarAssignService } from './rt-auto-car-assign.service';
import { BdsSmartComponentsModule } from '@bds/smart-components';
import { BdsCommodityModule } from '@bds/commodity';

@NgModule({
    declarations: [RtAutoCarAssignDetailsDialogComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BourqueCoreModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        FontAwesomeModule,
        DevExtremeModule,
        BdsSmartComponentsModule,
        BdsCommodityModule,
    ],
    exports: [RtAutoCarAssignDetailsDialogComponent],
    providers: [RtAutoCarAssignService],
})
export class RtAutoCarAssignModule {}
